export enum HorizontalFieldlineThemeEnum {
  FullSize = 'fullSize',
  Inner = 'inner',
}
